import React, { useState, useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import {
  getSpecificGtwCategoryRequest,
  saveGtwCategory,
} from '../requests/gtwRequests';

import 'moment/locale/pl';

const GtwCategoriesEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);

  useEffect(() => {
    toggleLoading(true);
    getSpecificGtwCategoryRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['name'],
              value: data.name,
            },
            {
              name: ['sortOrder'],
              value: data.sortOrder,
            },
            {
              name: ['isActive'],
              value: data.isActive || false,
            },
          ]);
          if (data.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/gtw-categories');
        }
      })
      .catch(() => {
        history.push('/gtw-categories');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveGtwCategory(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Ustawienia treści</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gtw-categories">Baza wiedzy</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/gtw-categories/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="name"
                label="Nazwa"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="sortOrder"
                label="Kolejność"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        if (
                          (value.length > 5 ||
                            !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                          value.length > 0
                        ) {
                          return Promise.reject(
                            new Error('Proszę podać poprawną wartość!')
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{
                    width: '100px',
                  }}
                />
              </Form.Item>
              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/gtw-categories">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/gtw-categories">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default GtwCategoriesEdit;
